import { Timestamp } from "@firebase/firestore";

/**
 * Firestore notifications 컬렉션의 Notification 문서 인터페이스
 */
export interface Notification {
  notificationId: string;
  title: string;
  body: string;
  content?: any; // 알림과 연결된 콘텐츠 ID (예: 이벤트 ID, 공지사항 ID 등)
  targetType: 'all' | 'token_list' | 'approved_optional_users'; // 발송 대상 타입
  targetTokens: string[] | null; // targetType이 'token_list'일 때 사용
  status: 'pending' | 'sent' | 'failed'; // 발송 상태
  scheduledAt: Timestamp; // 예약 발송 시각
  sentAt: Timestamp | null; // 실제 발송된 시각
  failedAt: Timestamp | null; // 발송 실패 시각
  createdAt: Timestamp;
  userId: string; // 알림을 생성한 사용자 ID (선택적)
  targetUsers: string[] | null; // 알림을 받을 사용자 ID 목록 (선택적)
  targetEnterprises: string[] | null; // 알림을 받을 기업 ID 목록 (선택적)
}

/**
 * Notification 컬렉션 경로 상수
 */
export const NOTIFICATIONS_COLLECTION = process.env.REACT_APP_NOTIFICATIONS_COLLECTION as string;

/**
 * 알림 발송 대상 타입 상수
 */
export const NOTIFICATION_TARGET_TYPES = {
  ALL: 'all',
  TOKEN_LIST: 'token_list',
  APPROVED_OPTIONAL_USERS: 'approved_optional_users',
} as const;

/**
 * 알림 발송 상태 상수
 */
export const NOTIFICATION_STATUS = {
  PENDING: 'pending',
  SENT: 'sent',
  FAILED: 'failed',
} as const; 
